(function($) {
    class MenuMobile {
        constructor(element) {
            this.element = element;
            this.menuIsActive = false;
            this.menu = element.querySelector('.c-menu-mobile__menu');
            this.toggler = element.querySelector('.c-menu-mobile__toggler');
    
            this.toggler.addEventListener('click', () => this.toggleMenu());
        }
    
        toggleMenu() {
            this.menu.classList.toggle('is-active');
            this.toggler.classList.toggle('is-open');
            this.menuIsActive = !this.menuIsActive;
    
            this.toggleOverflow();
        }
    
        toggleOverflow() {
            // Calculate scrollbar width by comparing window inner width with document client width
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            
            if (this.menuIsActive) {
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            } else {
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0';
            }
        }
    }
    const baseUrl = `/wp-content/themes/ATS`;
    
    document.addEventListener('DOMContentLoaded', () => {
        const element = document.querySelector('.js-menu-mobile');
        if (element) {
            new MenuMobile(element);
            
            // Pobierz SVG jako kod i wstaw do elementów menu
            fetch(`${baseUrl}/dist/img/menu-arrow.svg`)
                .then(response => response.text())
                .then(svgContent => {
                    $('.menu-item-has-children > a').append(`<span class="dropdown-toggle">${svgContent}</span>`);
                    // Po dodaniu SVG, zainicjalizuj obsługę mobile menu
                    initMobileMenuHandlers();
                })
                .catch(error => {
                    console.warn('Nie można załadować SVG:', error);
                    // Fallback do img jeśli SVG się nie załaduje
                    $('.menu-item-has-children > a').append(`<span class="dropdown-toggle"><img src="${baseUrl}/dist/img/menu-arrow.svg"></span>`);
                    // Po dodaniu fallback, zainicjalizuj obsługę mobile menu
                    initMobileMenuHandlers();
                });
        }
    });
    
    function initMobileMenuHandlers() {
        // Add hover event for desktop menu
        if (!window.matchMedia('(max-width: 1199px)').matches) {
            $('.menu-item-has-children').hover(
                function() {
                    // Mouse enter
                    $(this).find('ul.sub-menu').css('display', 'flex');
                }, 
                function() {
                    // Mouse leave
                    $(this).find('ul.sub-menu').css('display', '');
                }
            );
        }

        if (window.matchMedia('(max-width: 991px)').matches) {
            // Dodaj kliwalny element span do każdego linku z submenu
    
            $('.menu-item-has-children > a').each(function(){
                var $link = $(this);
                var wasOpened = false;
    
                // Obsługa kliknięcia na strzałkę
                $link.find('.dropdown-toggle').on('click', function(e){
                    e.stopPropagation();
                    e.preventDefault();
                    
                    var $submenu = $link.next('.sub-menu');
                    $submenu.slideToggle('slow');
                    $link.toggleClass('active');
                    wasOpened = !wasOpened;
                });
    
                // Obsługa kliknięcia na link (ale nie na strzałkę)
                $link.on('click', function(e){
                    // Sprawdź czy kliknięto bezpośrednio na strzałkę
                    if ($(e.target).closest('.dropdown-toggle').length > 0) {
                        return; // Jeśli kliknięto na strzałkę, nie rób nic więcej
                    }
                    
                    if (!wasOpened) {
                        e.preventDefault();
                        // Bezpośrednio uruchom funkcjonalność rozwinięcia bez trigger
                        var $submenu = $link.next('.sub-menu');
                        $submenu.slideToggle('slow');
                        $link.toggleClass('active');
                        wasOpened = true;
                    } else {
                        // Jeśli już otwarte, pozwól na nawigację
                        window.location.href = $link.attr('href');
                    }
                });
            });
            
            // Dodaj obsługę kliknięcia poza menu, aby resetować flagę
            $(document).on('click', function(e){
                if (!$(e.target).closest('.menu-item-has-children').length) {
                    $('.menu-item-has-children > a').each(function(){
                        // Resetuj stan dla każdego linku
                        $(this).data('wasOpened', false);
                    });
                    $('.sub-menu').slideUp('slow');
                    $('.menu-item-has-children > a').removeClass('active');
                }
            });
        }
    }
})(jQuery);